import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Button } from 'reactstrap';
import axiosInstance from '../../helpers/axios';

const DisbursementModal = ({
  isOpen,
  onClose,
  displaySelected,
  selectedName,
  applicationId,
  user,
  onSuccess
}) => {
  const [adjustmentAmt, setAdjustmentAmount] = useState(null);
  const [sourceAccNum, setSourceAccountNumber] = useState("Src Acc No.");
  const [amtNotes, setAmountNotes] = useState(null);
  const [advChecked, setAdvChecked] = useState(true);
  const [pfsChecked, setPfsChecked] = useState(true);

  function formatNumberWithCommas(number) {
    return number?.toLocaleString('en-IN');
  }

  const calculateDisbursementAmount = () => {
    return displaySelected?.amountToBeDisbursed - 
      ((advChecked && displaySelected?.advanceEmiStatus === 1) ? (displaySelected?.advanceEmiAmount || 0) : 0) - 
      ((pfsChecked && displaySelected?.processingFeeStatus === 1) ? (displaySelected?.processingFees || 0) : 0) - 
      (adjustmentAmt || 0) +
      (displaySelected?.instituteId === '0943e9e2-82d3-42c9-b844-93a742936720'
        ? displaySelected?.subventionAmountGST 
        : 0);
  };

  const handleSubmit = () => {
    const disbursedAmount = calculateDisbursementAmount();
    const urlSendForDisbursement = `/disbursement/change-status`;

    if (amtNotes != null && sourceAccNum !== "Src Acc No.") {
      const data = {
        applicationId: applicationId,
        adjustedAmount: adjustmentAmt,
        fundSource: sourceAccNum,
        disbursementAmount: disbursedAmount,
        notes: amtNotes?.trim(),
        pfDeducted: !(
          (displaySelected?.processingFeeStatus === 2 || displaySelected?.processingFeeStatus === 3) || !pfsChecked
        ),
        advEmiDeducted: !(
          (displaySelected?.advanceEmiStatus === 2 || displaySelected?.advanceEmiStatus === 3) || !advChecked
        )
      };

      axiosInstance.post(urlSendForDisbursement, data, {
        headers: {
        }
      })
        .then((res) => {
          onClose();
          alert(res.data.message);
          setTimeout(() => {
            if (onSuccess) {
              onSuccess();
            } else {
              window.location.reload(true);
            }
          }, 500);
        })
        .catch((error) => alert(error?.response?.data?.message));
    } else {
      alert("Please fill Notes and Src Acc No.");
    }
  };

  const handleClose = () => {
    // Reset state on close
    setAdjustmentAmount(null);
    setSourceAccountNumber("Src Acc No.");
    setAmountNotes(null);
    setAdvChecked(true);
    setPfsChecked(true);
    onClose();
  };

  return (
    <Modal size="xl" isOpen={isOpen}>
      <ModalHeader>Create Disbursement</ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            {displaySelected ? (
              <>
                <div style={{display:"flex",flexDirection:"row",justifyContent:"space-between",backgroundColor:'#FCF0F1',width:"100%",borderRadius:"10px"}}>
                  <p style={{marginLeft:"15px",fontFamily:"Inter-Medium",fontSize:"14px",color:"#D32028"}}>Application ID <br/><span style={{fontFamily:"Inter-Medium",fontSize:"14px",color:"black"}}>{displaySelected.applicationId}</span></p>
                  <p style={{marginRight:"15px",fontFamily:"Inter-Medium",fontSize:"14px",color:"#D32028"}}> Applicant Name<br/><span style={{fontFamily:"Inter-Medium",fontSize:"14px",color:"black"}}>{selectedName}</span></p>
                </div>
                <div style={{display:'flex',justifyContent:'space-around'}}>
                  <div>
                    <div style={{display:'flex'}}>
                      <div style={{width:'12rem'}}>Loan Amount : </div>
                      <div style={{color:'black',fontWeight:'700'}}>₹{formatNumberWithCommas(displaySelected?.amount)}</div>
                    </div>
                    <div style={{display:'flex'}}>
                      <div style={{width:'12rem'}}>Tenure :  </div>
                      <div style={{color:'black',fontWeight:'700'}}>{displaySelected?.tenure}</div>
                    </div>
                    <div style={{display:'flex'}}>
                      <div style={{width:'12rem'}}>Emi : </div>
                      <div style={{color:'black',fontWeight:'700'}}>₹{formatNumberWithCommas(displaySelected?.emi)}</div>
                    </div>
                    <div style={{display:'flex'}}>
                      <div style={{width:'12rem'}}>Adv. Months : </div>
                      <div style={{color:'black',fontWeight:'700'}}>{displaySelected?.advanceEmis?displaySelected?.advanceEmis:0}</div>
                    </div>
                    <div style={{display:'flex'}}>
                      <div style={{width:'12rem'}}>                  
                        <input type='checkbox' checked={advChecked} onChange={()=>setAdvChecked(!advChecked)} disabled={displaySelected?.advanceEmiStatus === 2 || displaySelected?.advanceEmiStatus === 3} style={{marginRight:'10px'}}></input>Advance : 
                      </div>
                      <div style={{color:'black',fontWeight:'700',display:'flex'}}>
                        ₹{advChecked?formatNumberWithCommas(displaySelected?.advanceEmiAmount?displaySelected?.advanceEmiAmount:0):"0"}  
                        <span style={{marginLeft:'20px'}}>
                          {displaySelected?.advanceEmiStatus === 2?<p style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',marginTop:'10px'}}></p>:displaySelected?.advanceEmiStatus === 3?<p style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',marginTop:'10px',fontWeight:'700',display:'flex',justifyContent:'center',alignItems:'center',color:'black'}}>NA</p>:null}
                        </span>
                      </div>
                    </div>
                    <div style={{display:'flex'}}>
                      <div style={{width:'12rem'}}>                  
                        <input type='checkbox' checked={pfsChecked} onChange={()=>setPfsChecked(!pfsChecked)} disabled={displaySelected?.processingFeeStatus === 2 || displaySelected?.processingFeeStatus === 3} style={{marginRight:'10px'}}></input>Pf : 
                      </div>
                      <div style={{color:'black',fontWeight:'700',display:'flex'}}>
                        ₹{pfsChecked?formatNumberWithCommas(displaySelected?.processingFees?displaySelected?.processingFees:0):"0"}  
                        <span style={{marginLeft:'30px'}}>
                          {displaySelected?.processingFeeStatus === 2?<p style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',marginTop:'10px'}}></p>:displaySelected?.processingFeeStatus === 3?<p style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',marginTop:'10px',fontWeight:'700',display:'flex',justifyContent:'center',alignItems:'center',color:'black'}}>NA</p>:null}
                        </span>
                      </div>
                    </div>
                    <div style={{display:'flex'}}>
                      <div style={{width:'12rem'}}>Subvention : </div>
                      <div style={{color:'black',fontWeight:'700'}}>₹{formatNumberWithCommas(displaySelected?.subventionAmount?displaySelected?.subventionAmount:0)}</div>
                    </div>
                    <div style={{display:'flex'}}>
                      <div style={{width:'12rem'}}> GST on Subvention: </div>
                      <div style={{color:'black',fontWeight:'700'}}>
                        ₹{formatNumberWithCommas(displaySelected?.instituteId === '0943e9e2-82d3-42c9-b844-93a742936720' ? 0 : displaySelected?.subventionAmountGST ?? 0)}
                      </div>
                    </div>
                    <div style={{display:'flex'}}>
                      <div style={{width:'12rem'}}>Adjusted Amount : </div>
                      <input placeholder='₹' onChange={(e)=>setAdjustmentAmount(e.target.value ? parseFloat(e.target.value) : 0)} style={{borderRadius:'5px',width:'10em',height:'3em',padding:'0.5em'}}></input>
                    </div>
                    <div style={{marginTop:'10px',display:'flex'}}>
                      <div style={{width:'12rem'}} >Amt. to be Disbursed :</div>
                      <div style={{color:'black',fontWeight:'700'}} >
                        <input style={{borderRadius:'5px',width:'10em',height:'3em',padding:'0.5em'}} disabled 
                          value={calculateDisbursementAmount()} 
                        />
                      </div>
                    </div>
                  </div>
                  <div>
                    <p style={{fontWeight:'700',width:'14.5em'}}>Bank Details</p>
                    <p style={{width:'15em'}}><span style={{fontWeight:'550'}}>Bank Name:</span> {displaySelected.bankDetails.bank_name}</p>
                    <p style={{width:'15em'}}><span style={{fontWeight:'550'}}>IFSC:</span> {displaySelected.bankDetails.ifsc}</p>
                    <p style={{width:'15em'}}><span style={{fontWeight:'550'}}>Merchant Name:</span> {displaySelected.bankDetails.name}</p>
                    <p style={{width:'15em'}}><span style={{fontWeight:'550'}}>Acc No. :</span>{displaySelected.bankDetails.account_number}</p>
                    <div style={{display:'flex',justifyContent:'space-between',}}>
                      <select onChange={(e)=>setSourceAccountNumber(e.target.value)} style={{ backgroundColor: '#7057EA',height:'2.5em',borderRadius:'5px',color:'white',fontWeight:'500',padding:'10px',paddingBottom:'5px',paddingTop:'5px'}}  >
                        <option value="Src Acc. No.">Src Acc No.</option>
                        <option value="409001784252">RBL Bank , 409001784252</option>
                      </select>
                      <p style={{paddingLeft:'1em',paddingRight:'1em',fontWeight:'600',marginTop:'0.2em'}}>To</p>
                      <Button style={{height:'2.5em'}} color="primary" type="button">{displaySelected.bankDetails.account_number}</Button>
                    </div>
                  </div>
                </div>
                <div style={{display:'flex',marginLeft:'4.5rem',marginTop:'1rem'}}>
                  <div style={{width:'12rem'}}>Notes :</div>
                  <input onChange={(e)=>setAmountNotes(e.target.value)} style={{borderRadius:'5px',width:'18em',height:'3em',padding:'0.5em'}}></input>
                </div>
              </>
            ) : null}
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button onClick={handleClose}>Close Box</Button>
        <Button style={{backgroundColor:'#D32028',border:'none'}} onClick={() => handleSubmit()}>Create Disbursement</Button>
      </ModalFooter>
    </Modal>
  );
};

export default DisbursementModal;
